import type { ResultState } from "../engine/engine.types.js";

/**
 * Typed event surface from §10 of the spec. No real transport is wired yet
 * — Incremento 5 decides where these go and under what consent. For now
 * every event is only logged to the console in dev and otherwise dropped,
 * so the rest of the app can be built against the final event shapes.
 * Never send full free-text answers here.
 */
export type AnalyticsEvent =
  | { name: "session_started"; sessionId: string }
  | { name: "intro_completed"; sessionId: string }
  | { name: "question_viewed"; sessionId: string; questionId: string }
  | { name: "answer_submitted"; sessionId: string; questionId: string }
  | { name: "answer_changed"; sessionId: string; questionId: string }
  | { name: "differentiation_started"; sessionId: string; questionId: string }
  | { name: "differentiation_completed"; sessionId: string }
  | { name: "result_generated"; sessionId: string; resultState: ResultState }
  | { name: "result_viewed"; sessionId: string; resultState: ResultState }
  | { name: "result_feedback"; sessionId: string; reaction: string }
  | { name: "recommendation_viewed"; sessionId: string; route: string }
  | { name: "recommendation_clicked"; sessionId: string; route: string }
  | { name: "experiment_viewed"; sessionId: string; experimentId: string }
  | { name: "experiment_accepted"; sessionId: string; experimentId: string }
  | { name: "followup_opt_in"; sessionId: string }
  | { name: "followup_returned"; sessionId: string }
  | { name: "experiment_completed"; sessionId: string }
  | { name: "session_abandoned"; sessionId: string; screen: string };

export interface EventContext {
  contentVersion: string;
  engineVersion: string;
  timestamp: number;
}

let sink: (event: AnalyticsEvent, ctx: EventContext) => void = () => {
  /* no-op transport until Incremento 5 */
};

export function setAnalyticsSink(fn: typeof sink): void {
  sink = fn;
}

export function track(event: AnalyticsEvent, ctx: Omit<EventContext, "timestamp">): void {
  try {
    sink(event, { ...ctx, timestamp: Date.now() });
  } catch {
    // A broken analytics transport must never block the user's experience.
  }
}
